import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M21 12.87a1.928 1.928 0 00-1.929-1.928h-1.465l-.849-2.571a1.903 1.903 0 00-1.826-1.286h-1.967V5.478a.964.964 0 00-1.928 0v1.607H9.75a1.903 1.903 0 00-1.826 1.286l-.848 2.571H4.929A1.928 1.928 0 003 12.871v2.571a1.941 1.941 0 00.771 1.543.295.295 0 00.335 0 .308.308 0 00.18-.257 3.214 3.214 0 116.428 0c.007.098.007.197 0 .296a.336.336 0 00.077.244.347.347 0 00.245.103h1.941a.347.347 0 00.309-.103.335.335 0 000-.244 2.244 2.244 0 010-.296 3.214 3.214 0 116.428 0 .308.308 0 00.18.283.295.295 0 00.335 0 1.942 1.942 0 00.77-1.569v-2.571z",
      fill: "#333"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M7.499 18.656a1.929 1.929 0 100-3.857 1.929 1.929 0 000 3.857zM16.499 18.656a1.929 1.929 0 100-3.857 1.929 1.929 0 000 3.857z",
      fill: "#333"
    }
  )
), l = t;
export {
  l as default
};
